import { imageSizeChoices } from 'apps/studio/components/settings/fields/Base/advanced'
import {
  MakeAllowUnsecuredAccessToggle,
  BothVisibilitySelects,
  Labels,
  AdvancedSettingsPanel,
} from 'apps/studio/components/settings/fields/Base/advanced'

export const TilePhoto = {
    label: 'Tile Photo',
    settingType: 'toggleInput',
    property: 'uses_caption_format',
}

export const PhotoSize = {
    label: 'Photo Size',
    settingType: 'selectInput',
    property: 'style',
    choices: imageSizeChoices,
    isDisabled: ({ uses_caption_format }) => uses_caption_format,
}

export const MediaSource = {
    label: 'Image Source',
    settingType: 'selectInput',
    property: 'mask',
    labelAbove: true,
    dynamicChoices: ({ mask }) => {
        const isAllowDrawingEnabled = mask >= '10'
        return [
            {
                value: isAllowDrawingEnabled ? '10' : '00',
                label: 'Camera or Gallery',
            },
            {
                value: isAllowDrawingEnabled ? '11' : '01',
                label: 'Camera Only',
            },
            {
                value: isAllowDrawingEnabled ? '12' : '02',
                label: 'Gallery Only',
            },
        ]
    },
}

export const PhotoAdvancedSettings = AdvancedSettingsPanel([
  MediaSource,
  TilePhoto,
  PhotoSize,
  MakeAllowUnsecuredAccessToggle('images'),
  ...BothVisibilitySelects,
  ...Labels,
])
